import { render, staticRenderFns } from "./technologyService.vue?vue&type=template&id=18f060cc&scoped=true"
import script from "./technologyService.vue?vue&type=script&lang=js"
export * from "./technologyService.vue?vue&type=script&lang=js"
import style0 from "./technologyService.vue?vue&type=style&index=0&id=18f060cc&prod&lang=less&scoped=true"
import style1 from "./technologyService.vue?vue&type=style&index=1&id=18f060cc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f060cc",
  null
  
)

export default component.exports